import { first } from "lodash";

export const ANALYTICS = {
  PAGEVIEWS: "pageviews",
  CRASH_REPORT: "crash_report",
};

export const ANALYTICS_CONFIG = {
  [ANALYTICS.PAGEVIEWS]: {
    label: "Pageviews",
    description:
      "While you're on the app, we will increment a counter in the database per page, per hour by UTC time.\n\nIt will NOT detect the exact page viewed, only the base (Characters, Ships, etc.). There is no tying this number back to the user viewing the page.",
    explanation:
      "We want to ensure the app is making as few reads as possible. If a spike in page reads doesn't correlate to an increased number of users on the platform, then we may have some performance issues we need to investigate. Also, we want to ensure that we perform releases at low traffic times when few users are present on the app.",
  },
  [ANALYTICS.CRASH_REPORT]: {
    label: "Crash Report",
    description:
      "Whenever you reach the error page, the following information will be saved in our database:\n- the current URL\n- the reason for the error\n- your user agent (browser and OS)\n\nIt will not tell us which user experienced the error, but we will know which sheet caused the issue because of the sheet's ID in the URL.",
    explanation:
      "We want to know if issues are happening in the app and what caused them, so we can fix them as soon as possible.",
  },
};

export const analyticsLog = [
  {
    version: "1.0.0",
    description: `We've added new analytics to our app! This allows us to track whenever
          certain things happen in the app. However, we need your consent before
          we do! We ensure you these analytics contain no trace back to the user
          and we will never sell this data. It is to help us keep the app
          functional.`,
    changes: {
      [ANALYTICS.PAGEVIEWS]: true,
      [ANALYTICS.CRASH_REPORT]: true,
    },
  },
];

export const latestAnalyticsVersion = first(analyticsLog).version;
